import { type ReactNode } from 'react'
import { OpenFeatureProvider } from '@openfeature/react-sdk'
import { OpenFeature } from '@openfeature/web-sdk'
import { StatsigWebProvider, type RolloutTier } from './StatsigWebProvider'

// Guard the global provider registration so it runs once even under StrictMode's
// dev double-mount.
let configured = false

/**
 * Wrap your app once. Registers the Statsig-backed OpenFeature provider for this
 * environment and exposes flags to `useFlag`. With an empty `clientKey` it stays
 * the OpenFeature no-op default, so a workload is safe before its key is wired.
 */
export function RolloutProvider({
  clientKey,
  environment,
  children,
}: {
  /** Statsig CLIENT key for this environment (public). Empty = rollout off; flags read defaults. */
  clientKey: string
  /** Environment tier — gates resolve for exactly this environment. */
  environment: RolloutTier
  children: ReactNode
}) {
  if (!configured && clientKey) {
    OpenFeature.setProvider(new StatsigWebProvider(clientKey, environment))
    configured = true
  }
  return <OpenFeatureProvider>{children}</OpenFeatureProvider>
}
